export class QnrFieldValidationMessage {
  static readonly formulaFieldValidationMessage = "The value of this cell is calculated by a formula in the Excel workbook. So, you cannot give input in this cell.";
}
